import { Flex, theme } from "antd";

import StyledContainer from "./style";

import { ReactComponent as ArrowRight } from "../../image/arrow_right.svg";

const CardQuickStart = ({ onClick, Icon, style, title }) => {
  const { token } = theme.useToken();

  return (
    <StyledContainer onClick={onClick} style={style} token={token}>
      <Flex align="center" justify="space-between">
        <p className="label-quick-start">QUICK START</p>
        <Icon />
      </Flex>

      <Flex align="end" justify="space-between">
        <div className="title">{title}</div>
        <ArrowRight />
      </Flex>
    </StyledContainer>
  );
};

export default CardQuickStart;
